import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import "./PageLoading.css";

interface PageLoadingProps {
  tip?: string;
  fullScreen?: boolean;
}

const PageLoading: React.FC<PageLoadingProps> = ({
  tip = "Loading...",
  fullScreen = true,
}) => {
  return (
    <div
      className={`page-loading ${fullScreen ? "page-loading--fullscreen" : ""}`}
    >
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />}
        tip={tip}
      />
    </div>
  );
};

export default PageLoading;
